import React, { useState } from 'react'
import { MuiGrid, MuiTypography } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme';
import en from 'date-fns/locale/en-US';
import format from 'date-fns/format';
import { startOfWeek } from "date-fns";
import lodash from 'lodash';
import TimeHeaderComponent from './TimeHeaderComponent'
import addDays from 'date-fns/addDays';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    root: { margin: 10 },
    titleGridStyle: { background: theme.palette.grey.light, padding: 8, boxSizing: 'border-box', borderBottom: '1px solid  ' + theme.palette.grey.main, height: 'auto' },
    titleStyle: { fontWeight: 600 },
    cellGridStyle: { width: '100vw' },
    timeSlotGrid: { background: theme.palette.grey.lighter, width: '5vw' },
    dummySlotGrid: { height: '4vh', borderLeft: '1px solid  ' + theme.palette.grey.main, borderBottom: '1px solid  ' + theme.palette.grey.main, background: theme.palette.grey.lighter },
    dummySlot: { color: theme.palette.grey.light, fontWeight: 600, visibility: 'hidden' },
    timeGrid: { border: '1px solid  ' + theme.palette.grey.main, borderTop: 'none' },
    daysGrid: { background: theme.palette.grey.light, },
    daysGridContainer: { height: '4vh' },
    dayGridItem: { height: '4vh', borderRight: '1px solid  ' + theme.palette.grey.main, borderBottom: '1px solid  ' + theme.palette.grey.main, background: theme.palette.grey.lighter },
    dayText: { color: theme.palette.grey.dark, fontWeight: 600 }
}));

export default function CalendarGrid(props) {

    const i18n = props.i18n
    const originDate = startOfWeek(new Date(), { weekStartsOn: 1 });
    const classes = useStyles();

    const days = [{ code: 'su', "name": i18n.days.SUNDAY, index: 0 },
        { code: 'mo', "name": i18n.days.MONDAY, index: 1 },
    { code: 'tu', "name": i18n.days.TUESDAY, index: 2 },
    { code: 'we', "name": i18n.days.WEDNESDAY, index: 3 },
    { code: 'th', "name": i18n.days.THURSDAY, index: 4 },
    { code: 'fr', "name": i18n.days.FRIDAY, index: 5 },
    { code: 'sa', "name": i18n.days.SATURDAY, index: 6 }]
    const getDay = (day1) => {
        let day = days.find((d) => d.index == day1.dayNumber)
        return day.name

    }
    let slotCount = (props.lastHourSlot - props.startHourSlot)
    return (

        <MuiGrid xs={12} className={classes.root}>
            <MuiGrid container xs={12} className={classes.titleGridStyle} justify='space-between' alignItems='center'>
                <MuiGrid item >
                    <MuiTypography variant={theme.typographyStyles.TITLE} color='primary'
                        style={props.setTitleTextStyleBasedOnLicense(props.noOfTTShowIndex, props.index)}
                    >
                        {i18n.weeklyTimeTable.itemTitle}  {props.title != undefined && props.showText(props.title.toUpperCase(), props.timeTableType, props.index)}</MuiTypography></MuiGrid>
                <MuiGrid item >
                    <MuiTypography variant={theme.typographyStyles.BODY2} style={props.setSummaryTextStyleBasedOnLicense(props.noOfTTShowIndex, props.index)}>
                        <b>{i18n.weeklyTimeTable.itemSummaryLabel}</b>{i18n.weeklyTimeTable.itemSummaryDescription}
                    </MuiTypography></MuiGrid>
            </MuiGrid>

            <MuiGrid container xs={12} className={classes.cellGridStyle}>
                <MuiGrid container className={classes.timeSlotGrid}>
                    <MuiGrid item xs={12} className={classes.dummySlotGrid} align='center'>
                        <MuiTypography variant={theme.typographyStyles.BODY2} className={classes.dummySlot}>-</MuiTypography>
                    </MuiGrid>
                    <MuiGrid container xs={12} className={classes.timeGrid}>


                        <MuiGrid item xs={12}>
                            {lodash.times(slotCount + 1).map(i => (
                                <TimeHeaderComponent key={i} label={format(originDate.setHours((props.startHourSlot) + i), 'h a', { locale: en })} />
                            ))}
                        </MuiGrid>

                    </MuiGrid>


                </MuiGrid>
                <MuiGrid container xs className={classes.daysGrid}>
                    {/* <MuiGrid container xs={12} className={classes.daysGridContainer}>
                        {lodash.times(6).map(i => (
                            <MuiGrid item xs className={classes.dayGridItem} align='center'>
                                <MuiTypography variant={theme.typographyStyles.BODY2} className={classes.dayText}>{format(addDays(originDate, i), 'EEE', { locale: en })}</MuiTypography>

                            </MuiGrid>
                        ))}</MuiGrid> */}
                        <MuiGrid container xs={12} className={classes.daysGridContainer}>
                        {props.header.map(i => (
                            <MuiGrid item xs className={classes.dayGridItem} align='center'>
                                <MuiTypography variant={theme.typographyStyles.BODY2} className={classes.dayText}>{getDay(i)}</MuiTypography>

                            </MuiGrid>
                        ))}</MuiGrid>

                    <MuiGrid item xs={12}>{props.children}
                    </MuiGrid></MuiGrid>


            </MuiGrid>

        </MuiGrid>



    )
}